<template>
  <div>
    <div
      id="bottom_property"
      style="display: block"
      :style="{ height: hidebottom ? '33px' : '280px' }"
      v-show="bottomShow"
    >
      <div class="spliter"></div>
      <div class="container">
        <div class="header">
          <div class="icon"></div>
          <div class="title">查询结果:{{ titles }}</div>
          <div
            v-show="isClose"
            class="arrow"
            :class="hidebottom ? 't2b' : 'b2t'"
            v-on:click.stop="bottomhideClick()"
          ></div>
          <div v-show="isClose" class="close" v-on:click.stop="bottomRemoveClick()"></div>
        </div>
        <div class="content_table">
          <Spin class="demo-spin-col" v-show="spinshow">
            <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
            <div>Loading</div>
          </Spin>
          <!-- 带图层选择的 -->
          <Table
            v-if="dataSelect.length > 0"
            height="210"
            size="small"
            border
            :columns="columnsSelect"
            :data="dataSelect"
            class="selectTB"
          ></Table>
          <Table
            height="210"
            size="small"
            border
            :columns="columns1"
            :data="data134"
            @on-row-dblclick="ondbrowclick"
            @on-row-click="onrowclick"
            ref="table_property"
          >
            <template slot="action" slot-scope="{ row }">
              <Button type="primary" size="small" @click.stop="lookBusinessData(row)">查看</Button>
            </template>
          </Table>
          <Page
            v-if="!analysisdl && !analysis"
            :current.sync="pageinfo.current"
            :total="pageinfo.count"
            show-total
            class="pagecss"
            show-elevator
            @on-change="changepage"
          />
          <!-- 分析的表格翻页 -->
          <Page
            v-if="analysis"
            :current.sync="pageinfo.current"
            :total="pageinfo.count"
            show-total
            class="pagecss"
            show-elevator
            @on-change="commonAnalysis"
          />
          <div v-if="analysis || analysisdl || onlyExport || onlyExportxzjc">
            <!-- 通用分析和专题分析 -->
            <Button
              v-show="savelayerstatus.status"
              type="primary"
              class="b1"
              icon="ios-download-outline"
              @click="saveresult"
              :loading="savelayerstatus.loading"
            >
              <span v-if="!savelayerstatus.loading">保存图层</span>
              <span v-else>保存中</span>
            </Button>
            <Button
              v-if="analysis || analysisdl"
              type="primary"
              class="b1"
              icon="ios-download-outline"
              @click="exportresultYGAnalysis"
              :loading="exportloading"
            >
              <span v-if="!exportloading">导出查询结果</span>
              <span v-else>导出中</span>
            </Button>
            <Button
              v-else
              type="primary"
              class="b1"
              icon="ios-download-outline"
              @click="exportresult_common"
              :loading="exportloading"
            >
              <span v-if="!exportloading">导出查询结果</span>
              <span v-else>导出中</span>
            </Button>
          </div>
          <div v-else-if="noRelation">
            <Button
              type="primary"
              class="b1"
              icon="ios-download-outline"
              @click="exportresultNoRelation"
              :loading="exportloading"
            >
              <span v-if="!exportloading">导出查询结果</span>
              <span v-else>导出中</span>
            </Button>
          </div>
          <div v-else>
            <Button type="primary" class="b1" @click="oncefilter" icon="ios-funnel"
              >二次过滤</Button
            >
            <Button
              type="primary"
              class="b1"
              icon="ios-download-outline"
              @click="exportresult"
              :loading="exportloading"
            >
              <span v-if="!exportloading">导出查询结果</span>
              <span v-else>导出中</span>
            </Button>
            <Button
              v-if="!showStatus"
              type="primary"
              class="b1"
              @click="closeexport"
              icon="ios-flask"
              >过滤显示</Button
            >
            <Button
              v-if="showStatus"
              type="primary"
              @click="filterexport"
              class="b1"
              icon="ios-flask-outline"
              >完整显示</Button
            >
            <Button
              v-if="isExportShp"
              type="primary"
              class="b1"
              icon="ios-download-outline"
              @click="exportshp"
              :loading="shploading"
            >
              <span v-if="!shploading">导出shp</span>
              <span v-else>导出中</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
    <!-- 二次过滤设置 -->
    <Modal v-model="filtershow" :footer-hide="true" width="30%" :mask="false">
      <p
        class="modeltitle"
        slot="header"
        style="font-size: 14px; color: rgba(51, 51, 51, 1)"
      >
        <i></i>
        <span>二次过滤设置</span>
      </p>
      <div class="modelcontent" style="width: 100%; height: 100%">
        <Row>
          <Col span="24">
            <Table
              border
              height="130"
              :columns="columns_filter"
              :data="data_filter"
              @on-row-dblclick="filterfield"
            ></Table>
          </Col>
        </Row>
        <Row>
          <Col span="14">
            <ul class="filtersty">
              <li
                v-for="(item, index) in filter"
                :key="index"
                v-on:click.stop="filtertj(item, index)"
              >
                <Button>{{ item }}</Button>
              </li>
            </ul>
          </Col>
          <Col span="10">
            <Spin fix v-if="spintj"></Spin>
            <Table
              style="margin-top: 5px; margin-bottom: 2px"
              border
              height="120"
              :columns="columns_val"
              :data="data_val"
              @on-row-click="filterVal"
            ></Table>
            <Button disabled type="info" style="float: right">获取唯一值</Button>
          </Col>
        </Row>
        <Row>
          <Col span="24">
            <Form :label-width="170">
              <FormItem :label="layertitle" class="sqlstyle">
                <Input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 5 }"
                  placeholder="Enter something..."
                  v-model="filtercondition.Where"
                ></Input>
              </FormItem>
              <FormItem style="float: right">
                <Button
                  v-on:click.stop="apply"
                  :loading="applyloading"
                  style="margin-left: -25px"
                  type="success"
                >
                  <span v-if="!applyloading">应用</span>
                  <span v-else>查询中</span>
                </Button>
                <Button v-on:click.stop="testVerify" type="info">验证</Button>
                <Button v-on:click.stop="clear" type="warning">清空</Button>
              </FormItem>
            </Form>
          </Col>
        </Row>
        <!-- <Table border :columns="columns1" :data="data1"></Table> -->
      </div>
    </Modal>

    <!-- 上传后填写字段 -->
    <Modal
      v-model="addShow"
      :draggable="true"
      :footer-hide="true"
      width="40%"
      :mask="false"
    >
      <p
        class="modeltitle"
        slot="header"
        style="font-size: 14px; color: rgba(51, 51, 51, 1)"
      >
        <i></i>
        <span>填写数据</span>
      </p>
      <div class="modelcontent" style="width: 100%; height: 100%">
        <Row>
          <Col span="24">
            <Spin fix v-if="spintj"></Spin>
            <Table
              height="210"
              size="small"
              border
              :columns="columns2"
              :data="addTableData"
              @on-row-click="onrowclickAdd"
            >
              <template
                slot-scope="{ row, index }"
                :slot="col.title"
                v-for="(col, col_i) in columns2"
              >
                <Input
                  type="text"
                  v-model="row[col.title]"
                  v-if="['ID', '颜色', 'mpArea'].indexOf(col.title) < 0"
                />
                <span v-else>{{ row[col.title] }}</span>
              </template>
            </Table>
            <Button type="info" style="float: right">提交审核</Button>
          </Col>
        </Row>
      </div>
    </Modal>
  </div>
</template>

<script>
import BottomProperty from "./BottomProperty";
export default BottomProperty;
</script>
<style lang="less" scoped>
.demo-spin-container {
  display: inline-block;
  width: 200px;
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}
/deep/ .bi {
  margin-left: 20px;
  height: 30px;
  border-radius: 5px;
}
/deep/ .selectTB {
  height: 210px;
  float: left;
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 237px;
  position: absolute;
  border: 1px solid #eee;
  bottom: 0px;
  z-index: 999;
  width: 100%;
  background: white;
}
/deep/ .content_table .ivu-table-cell {
  text-align: center;
  padding: 0 !important;
}
/deep/ .pagecss {
  float: left;
  margin-left: 10px;
}
.b1 {
  height: 25px;
  margin-left: 20px;
  line-height: 25px;
  margin-top: 5px;
}
#bottom_property {
  position: absolute;
  bottom: 0;
  width: 100%;
  // left: 60px;
  right: 0;
  height: 207px;
  z-index: 1001;
  // border-top: 1px solid #ccc;
  display: none;
  overflow: hidden;
}
#bottom_property .spliter {
  position: absolute;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #ddd;
}

#bottom_property .container {
  position: absolute;
  top: 2px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  width: 100%;
}
#bottom_property .header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 30px;
  line-height: 30px;
  background-color: #0099fa;
  border-bottom: 1px solid #dddddd;
  color: white;
}
#bottom_property .header > .icon {
  height: 16px;
  width: 16px;
  position: relative;
  overflow: hidden;
  left: 5px;
  top: 7px;
  background-image: url(../../../static/img/ResourceView.png);
}
#bottom_property .header > div {
  float: left;
  font-size: 12px;
  margin-left: 7px;
}
#bottom_property .header > .b2t {
  background-image: url(../../../static/img/l1.png);
  background-position: -155px -12px;
}
#bottom_property .header > .t2b {
  background-image: url(../../../static/img/l1.png);
  background-position: -112px -12px;
}
#bottom_property .header > .close {
  background-position: -400px -6px;
  background-image: url(../../../static/img/l1.png);
  height: 16px;
  width: 16px;
  float: right;
  margin: 7px 5px 5px 0px;
  cursor: pointer;
}
#bottom_property .content_table {
  position: absolute;
  top: 30px;
  left: 0;
  right: 0;
  bottom: 0;
}
#bottom_property .header > .arrow {
  cursor: pointer;
  margin: 7px 5px 5px 0px;
  height: 16px;
  width: 16px;
  float: right;
}
.modeltitle {
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
}
.modeltitle i {
  border-radius: 2px;
  background: #3d92dc;
  width: 4px;
  height: 30px;
  float: left;
  margin: 0px 5px 0 20px;
}
.sqlstyle /deep/ .ivu-form-item-content {
  margin-left: 0px !important;
}
.sqlstyle /deep/ .ivu-form-item-content textarea {
  height: 90px !important;
}
.filtersty li {
  margin-right: 5px;
  display: inline-block;
  margin-top: 5px;
}
.filterfieldsty {
  height: 120px;
  overflow-y: auto;
  border: 1px solid #ccc;
  width: 100%;
  padding: 5px;
  margin-top: 5px;
}
.filterfieldsty li {
  height: 25px;
  line-height: 25px;
  border-bottom: 1px solid #ccc;
}
/deep/ .modelcontent .ivu-table td,
.modelcontent .ivu-table th {
  height: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/Bottomshow/BottomProperty.vue